import { ActionTypes } from "../Constants/ActionTypes";

export const fullPageLoading = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.FULL_PAGE_LOADING,
    payload: payload,
  });
};

export const setContentLayoutLoading = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.CONTENT_LAYOUT_LOADING,
    payload: payload,
  });
};
